module.exports = __webpack_public_path__ + "static/media/innovando-epi.23e8dadd.webp";